import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import ConvertActionButton from '../../../Reusable_Components/ConvertActionButton';

const CampaignRecipientsListDetails = () => {
  const { campaignId } = useParams();
  const navigate = useNavigate();
  const [campaign, setCampaign] = useState(null);
  const [recipients, setRecipients] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRecipients = useCallback(async () => {
    try {
      const res = await axios.get(`${API_DOMAIN}marketing/campaigns/${campaignId}/recipients/`, { headers });
      setRecipients(res.data?.data ?? []);
    } catch (err) {
      console.error('Error fetching campaign recipients:', err);
    } finally {
      setLoading(false);
    }
  }, [campaignId]);

  useEffect(() => {
    axios.get(`${API_DOMAIN}marketing/campaigns/${campaignId}/`, { headers })
      .then(res => setCampaign(res.data?.data ?? res.data))
      .catch(() => {});
    fetchRecipients();
  }, [campaignId, fetchRecipients]);

  const columns = [
    { label: 'Email', value: 'email' },
    { label: 'Name', value: (item) => item.full_name || '—' },
    { label: 'Status', value: 'status' },
    {
      label: 'Lead',
      value: (item) => item.lead_id ? (
        <Link to={`/lead/details/${btoa(item.lead_id)}`} style={{ color: 'var(--color-primary)' }}>
          View Lead #{item.lead_id}
        </Link>
      ) : (
        <ConvertActionButton
          label="Create Lead"
          url={`${API_DOMAIN}marketing/campaign-recipients/${item.id}/create-lead/`}
          body={{}}
          onDone={fetchRecipients}
          className="btn btn-secondary btn-sm"
        />
      ),
    },
  ];

  return (
    <div>
      <div className="page-header">
        <div className="page-header-left">
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: 'var(--text-muted)', marginBottom: 6 }}>
            <Link to="/marketing/campaign/list" style={{ color: 'var(--color-primary)' }}>Campaigns</Link>
            <span>›</span>
            <span>{campaign?.name || `Campaign #${campaignId}`}</span>
          </div>
          <h1 className="page-title" style={{ margin: 0 }}>{campaign?.name || 'Recipients'}</h1>
        </div>
        <div className="page-actions">
          <button className="btn btn-secondary" onClick={() => navigate('/marketing/campaign/list')}>← Back to Campaigns</button>
        </div>
      </div>
      <ListTemplate columns={columns} data={recipients} loading={loading} title="Recipients" />
    </div>
  );
};

export default CampaignRecipientsListDetails;
